import { css } from "../../../../../../styled-system/css";

export const styles = {
  content: ({ textAlign }) =>
    css({
      fontSize: "body.cat",
      lineHeight: "body.cat",
      letterSpacing: "body.cat",
      whiteSpace: "pre-wrap",
      textAlign: textAlign ? `var(--rich-text-wrapper-text-align)` : "left",
      marginTop: 0,
      desktop: {
        fontSize: "body.horse",
        lineHeight: "body.horse",
        letterSpacing: "body.horse",
      },
      "& h2, & h1": {
        fontSize: "heading.H2.mobile",
        lineHeight: "heading.H2.mobile",
        letterSpacing: "heading.H2.mobile",
        marginTop: 0,
        whiteSpace: "normal",
        desktop: {
          fontSize: "heading.H2.desktop",
          lineHeight: "heading.H2.desktop",
          letterSpacing: "heading.H2.desktop",
          marginTop: 0,
        },
      },

      "& ul": {
        marginBottom: "baseUnit.mobile3",
        textAlign: "left",
        marginLeft: "18px",
        "& li": {
          listStyle: "disc",
          marginY: 0,
          marginRight: 0,
          marginLeft: "baseUnit.mobile2",
          paddingLeft: "4px",
          fontSize: "body.cat",
          lineHeight: "body.cat",
          letterSpacing: "body.cat",
          desktop: {
            fontSize: "body.horse",
            lineHeight: "body.horse",
            letterSpacing: "body.horse",
          },
          _lastOfType: {
            paddingBottom: 0,
          },
          "& p": {
            marginBottom: 0,
          },
          "&::marker": {
            fontSize: "heading.H3.mobile",
            desktop: {
              fontSize: "body.horse",
            },
          },
        },
      },
      "& ol": {
        marginBottom: "baseUnit.mobile3",
        textAlign: "left",

        "& li": {
          listStyle: "decimal",
          margin: "0 0 0 20px",
          paddingLeft: "28px",
          fontSize: "body.cat",
          lineHeight: "body.cat",
          letterSpacing: "body.cat",
          desktop: {
            fontSize: "body.horse",
            lineHeight: "body.horse",
            letterSpacing: "body.horse",
          },
          "& p": {
            marginBottom: 0,
          },
        },
      },
      "& p": {
        fontSize: "body.cat",
        lineHeight: "body.cat",
        desktop: {
          fontSize: "body.horse",
          lineHeight: "body.horse",
        },
      },
      "& p:last-of-type": {
        margin: 0,
      },
      "& p, & ul:nth-last-of-type(-n+2)": {
        marginBottom: 0,
      },
      "& b": {
        fontWeight: "bold",
      },
      "& p ~ ul": {
        paddingTop: "baseUnit.mobile3",
      },
      "& table": {
        border: "1px solid",
        borderColor: "lightGrey",
        borderRadius: "8px",
        display: "flex",
        flexDirection: "column",
        "& tr": {
          display: "flex",
          borderBottom: "1px solid",
          borderBottomColor: "lightGrey",
          _firstOfType: {
            backgroundColor: "lightGrey.transparent",
            minHeight: "68px",
            fontWeight: 700,
            fontSize: "body.horse",
            letterSpacing: "body.horse",
          },
          _lastOfType: {
            borderBottom: "none",
          },
        },
        "& td": {
          display: "flex",
          alignItems: "center",
          maxWidth: "176px",
          minWidth: "95px",
          width: "100%",
          padding: "10px 12px",
          borderRight: "1px solid",
          borderRightColor: "lightGrey",
          _lastOfType: {
            borderRight: "none",
          },
        },
      },
      "& p a": {
        fontSize: "inherit",
        lineHeight: "inherit",
        letterSpacing: "inherit",
        textDecoration: "underline",
        textUnderlinePosition: "under",
        textDecorationColor: "skyBlue",
        textDecorationStyle: "dotted",
        textDecorationThickness: "13%",
        borderRadius: "4px",
        transition: "color 0.2s ease, text-decoration-color 0.2s ease",
        color: "skyBlue",
        _hover: {
          textDecorationStyle: "solid",
          color: "oceanBlue",
          textDecorationColor: "oceanBlue",
        },
        _focus: {
          outlineColor: "oceanBlue",
        },
        _focusVisible: {
          color: "oceanBlue",
          outline: "1px solid",
          outlineColor: "oceanBlue",
          outlineOffset: 0,
          textDecoration: "none",
        },
      },
    }),
};
